import { Component } from '@angular/core';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent {

  breadCrumbItems: Array<{}> | undefined;
  activeTab: 'esign' | 'estamp' = 'esign';

  ngOnInit(): void {
    this.updateBreadcrumb();
  }

  switchTab(tab: 'esign' | 'estamp') {
    this.activeTab = tab;
    this.updateBreadcrumb();
  }

  private updateBreadcrumb(): void {
    this.breadCrumbItems = [
      { label: 'AVSS ' + (this.activeTab === 'esign' ? 'E-Sign' : 'E-stamp') },
      { label: 'Dashboard', active: true }
    ];
  }
}
